import React from "react";
import { Loader } from "../Loader/Loader";
import { Select, Space } from "antd";
import { List, Row, Col, Typography } from "antd";
import { ArrowUpOutlined, MenuUnfoldOutlined } from "@ant-design/icons";
import btc from "../Assets/btc.png";
import eur from "../Assets/eur.png";
import { Card, Avatar } from "antd";
import { CrownFilled } from "@ant-design/icons";
import leader from "../Assets/leader.png";
import l1 from "../Assets/l1.png";
import l2 from "../Assets/l2.png";
import l3 from "../Assets/l3.png";
import { motion } from "framer-motion";
import { Grid } from "antd";

const { useBreakpoint } = Grid;

const { Title, Text } = Typography;

const data = [
  {
    icon: "https://img.icons8.com/color/25/brazil-circular.png", // your image path
    pair: "Adrian P.",
    result: -100,
  },
  {
    time: "15:19",
    date: "20 Sep",
    icon: "https://img.icons8.com/color/25/india-circular.png", // your image path
    pair: "Sankar",
    result: 1720,
  },
  {
    time: "17:40",
    date: "19 Sep",
    icon: "https://img.icons8.com/color/25/argentina-circular.png", // your image path
    pair: "Messi",
    result: -280,
  },
  {
    time: "17:10",
    date: "19 Sep",
    icon: "https://img.icons8.com/color/25/usa-circular.png", // your image path
    pair: "John",
    result: 1720,
  },
  {
    time: "15:19",
    date: "20 Sep",
    icon: "https://img.icons8.com/color/25/india-circular.png", // your image path
    pair: "Sankar",
    result: 1720,
  },
  {
    time: "17:40",
    date: "19 Sep",
    icon: "https://img.icons8.com/color/25/argentina-circular.png", // your image path
    pair: "Messi",
    result: -280,
  },
  {
    time: "17:10",
    date: "19 Sep",
    icon: "https://img.icons8.com/color/25/usa-circular.png", // your image path
    pair: "John",
    result: 1720,
  },
  {
    time: "15:19",
    date: "20 Sep",
    icon: "https://img.icons8.com/color/25/india-circular.png", // your image path
    pair: "Sankar",
    result: 1720,
  },
  {
    time: "17:40",
    date: "19 Sep",
    icon: "https://img.icons8.com/color/25/argentina-circular.png", // your image path
    pair: "Messi",
    result: -280,
  },
  {
    time: "17:10",
    date: "19 Sep",
    icon: "https://img.icons8.com/color/25/usa-circular.png", // your image path
    pair: "John",
    result: 1720,
  },
  {
    time: "15:19",
    date: "20 Sep",
    icon: "https://img.icons8.com/color/25/india-circular.png", // your image path
    pair: "Sankar",
    result: 1720,
  },
  {
    time: "17:40",
    date: "19 Sep",
    icon: "https://img.icons8.com/color/25/argentina-circular.png", // your image path
    pair: "Messi",
    result: -280,
  },
  {
    time: "17:10",
    date: "19 Sep",
    icon: "https://img.icons8.com/color/25/usa-circular.png", // your image path
    pair: "Nick",
    result: 1720,
  },
];
const LeaderBoard = ({ loader, setCollapsed }) => {

  const screens = useBreakpoint()
  const container = {
    hidden: { opacity: 0 },
    show: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1,
      },
    },
  };

  const child = {
    hidden: { opacity: 0, y: 5 },
    show: { opacity: 1, y: 0 },
  };

  return (
    <>
      {loader ? (
        <Loader />
      ) : (
        <>
          <motion.div variants={container} initial="hidden" animate="show">
           {screens.lg && <motion.div variants={child}>
              <div className="display-5 p-20 trad-pos">
                <div className="side-title">Leaders of the Week</div>
                <div
                  className="cursor nonea3"
                  onClick={() => setCollapsed(true)}
                  id="cs"
                >
                  <svg
                    width="17"
                    height="17"
                    viewBox="0 0 17 17"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M13.0215 1.70605C13.6494 1.07837 14.6661 1.07823 15.2939 1.70605C15.9218 2.33389 15.9208 3.34966 15.293 3.97754L15.2939 3.97852L10.7725 8.5L15.2939 13.0215C15.9217 13.6494 15.9209 14.6652 15.293 15.293C14.9799 15.6061 14.5678 15.7646 14.1572 15.7646C13.7469 15.7646 13.3345 15.6068 13.0215 15.2939L8.5 10.7725L3.97852 15.2939C3.66549 15.6068 3.25314 15.7646 2.84277 15.7646C2.43255 15.7646 2.02021 15.6063 1.70703 15.293C1.07904 14.6652 1.07825 13.6494 1.70605 13.0215L6.22754 8.5L1.70605 3.97852C1.0782 3.35062 1.07812 2.3339 1.70605 1.70605C2.33401 1.0781 3.35056 1.07844 3.97852 1.70605L8.5 6.22754L13.0215 1.70605Z"
                      fill="#82858E"
                      stroke="#82858E"
                      stroke-width="1.5294"
                    />
                  </svg>
                </div>
              </div>
            </motion.div>}
            <motion.div variants={child}>
              <div className="p-10">
                <motion.div variants={child}>
                  <Select
                    defaultValue={"AllPositions"}
                    style={{ width: "100%" }}
                    // onChange={handleChange}
                    suffixIcon={
                      <svg
                        width="14"
                        height="10"
                        viewBox="0 0 14 10"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M6.66667 10L0 0H14L6.66667 10Z"
                          fill="var(--fnt)"
                        />
                      </svg>
                    }
                    className="history-select"
                    options={[
                      {
                        value: "AllPositions",
                        label: (

                          <div className="display-5">
                            <div className="display-1">
                              <svg
                                width="20"
                                height="20"
                                viewBox="0 0 18 18"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M9.49796 17.9814C19.3356 17.4168 21.1646 3.5621 11.83 0.45092C9.24698 -0.413544 6.28533 -0.0203458 4.02558 1.50402H4.02621C2.97892 2.20035 2.08924 3.10848 1.41454 4.16983C0.739839 5.23118 0.295117 6.42217 0.10906 7.66598L0.108495 7.66559C-0.776847 13.2178 3.88191 18.3486 9.49796 17.9814ZM16.779 12.2791C16.4578 13.0394 16.0262 13.7482 15.4981 14.3824C15.4608 14.1601 15.5637 13.9027 15.4104 13.6952C15.2441 13.3709 15.09 13.0402 14.9167 12.7198C14.8523 12.6006 14.8701 12.5322 14.965 12.4464C15.9821 11.554 15.0754 12.0285 15.1753 10.753C15.1789 10.7185 15.1721 10.6838 15.1557 10.6532C15.1393 10.6227 15.1142 10.5978 15.0835 10.5817C14.6014 10.2739 13.972 10.1681 13.4738 10.5102C12.8528 10.8037 11.9671 10.5792 11.7663 9.8665C11.5886 9.39276 11.6104 8.91436 11.6058 8.43055C11.6344 8.16964 11.9923 8.12584 11.9343 7.82427C11.948 7.44135 11.8232 7.03713 12.1854 6.78721C12.2131 6.76272 12.2462 6.74504 12.2819 6.73556C12.3177 6.72609 12.3552 6.72509 12.3914 6.73263C12.7223 6.77265 13.0567 6.69467 13.3357 6.51242C13.6316 6.32481 13.997 6.44626 14.3248 6.40355C14.481 6.39242 14.5968 6.43831 14.693 6.55993C14.8821 6.79873 15.178 6.86885 15.4265 7.01389C15.5101 7.06267 15.555 7.00117 15.5942 6.95059C15.803 6.6812 16.123 6.5907 16.4036 6.4358C16.5564 6.34823 16.8628 6.68254 17.1237 6.69441C17.6435 8.51384 17.5228 10.5393 16.779 12.2791ZM16.6568 5.44102C16.3453 5.482 16.5548 5.18608 16.394 5.03126C16.2326 4.88719 16.079 4.73453 15.934 4.57394C15.8589 4.49376 15.8104 4.48086 15.7236 4.56653C15.4904 4.7972 15.5035 4.77272 15.7754 5.04835C16.0928 5.39729 16.3321 5.39146 15.7577 5.63393C15.627 5.69278 15.5036 5.82687 15.361 5.63312C15.2746 5.51588 15.1571 5.4371 15.1711 5.25649C15.1925 4.97799 14.98 4.77607 14.8817 4.53562C14.8524 4.46387 14.8005 4.51442 14.7728 4.54975C14.566 4.81567 14.2535 4.91847 13.9705 5.06619C13.4817 5.49362 13.5933 5.44706 12.9446 5.42848C12.8845 5.43106 12.8668 5.35865 12.8408 5.31633C12.5141 4.78158 12.5775 4.65123 12.9159 4.14641C13.0404 4.07173 13.5904 4.15793 13.6943 4.26651C13.7411 4.31526 13.7794 4.37206 13.8469 4.45705C13.8987 4.25005 13.8724 4.09144 13.8778 3.9352C13.9655 3.2941 14.5042 3.58302 14.8866 3.44377C15.0674 3.30561 15.1415 3.23683 15.1032 3.16905C15.7425 3.83576 16.2674 4.6034 16.6568 5.44102ZM15.0509 3.11539C14.7899 2.94544 14.21 2.76627 14.1946 2.34634C14.4973 2.58271 14.7835 2.83967 15.0509 3.11539ZM3.04595 3.03414C3.53253 2.54685 4.07695 2.12096 4.66704 1.76599C4.86771 1.86843 5.01089 2.24531 5.26261 2.11139C5.53108 1.97052 5.81721 1.85878 6.00994 1.60688C6.11913 1.47424 6.3102 1.57576 6.4528 1.53553C7.01348 1.45962 7.16505 2.098 7.37478 2.47778C7.35627 2.49336 7.34652 2.5083 7.33846 2.50738C6.85197 2.45249 6.40589 2.60869 5.965 2.77846C5.82017 2.83424 5.70855 2.83897 5.61794 2.69951C5.50596 2.52706 5.36208 2.52208 5.18345 2.59647C5.01799 2.71343 4.42351 2.73364 4.46459 2.96837C4.50493 3.1889 4.33082 3.56479 4.72666 3.48965C4.91215 3.42512 5.07161 3.97325 5.18497 3.65812C5.42821 2.67256 6.45369 3.53261 7.24439 2.90288C7.53529 2.73028 7.77455 3.29879 7.88758 3.49905C7.97349 3.68694 8.03563 3.90814 8.33769 3.84262C8.14828 4.0321 7.95756 4.22031 7.77027 4.41184C7.71594 4.4674 7.66656 4.4496 7.60555 4.42841C7.37008 4.34666 7.13139 4.274 6.89673 4.18996C6.78478 4.14987 6.73109 4.14595 6.73363 4.29594C6.92523 5.32742 6.04653 4.33261 5.4363 5.10614C4.67484 5.87142 5.26413 6.51362 4.2176 7.31814C4.15504 7.37558 4.10308 7.3825 4.04122 7.33707C3.5866 7.01435 2.56515 6.839 2.22554 7.36653C2.22066 7.38243 2.21948 7.39922 2.22206 7.41564C2.22464 7.43206 2.23093 7.44768 2.24044 7.46131C2.42233 7.75284 2.4366 8.24333 2.78194 7.75429C2.88473 7.66669 3.00547 7.69618 3.11074 7.71367C3.22148 7.73207 3.16648 7.84935 3.16372 7.91756C3.17937 8.18956 3.57063 8.23803 3.49366 8.54422C3.44975 8.76574 3.72878 8.64331 3.85139 8.68047C4.0496 8.70905 4.19997 8.64274 4.32704 8.48795C4.4234 8.37057 4.97655 8.2908 5.10393 8.36633C5.20492 8.4681 5.24735 8.6271 5.3198 8.75137C5.44022 8.99299 5.44541 8.99786 5.62267 8.8069C6.02997 8.48717 6.60247 8.74013 6.99002 8.96215C7.29448 9.1327 7.19391 9.74155 7.64745 9.65405C7.73456 9.63349 7.78168 9.70771 7.82944 9.76151C8.15888 10.1645 8.6908 10.1163 8.88565 10.669C9.01119 10.8995 8.99777 11.1015 8.89109 11.3295C8.81528 11.7579 8.60464 12.0735 8.15987 12.1935C7.80719 12.3201 8.40219 12.8956 7.59492 13.1251C7.38788 13.1701 7.36107 13.3287 7.38788 13.5146C7.47351 13.9936 7.35722 14.355 6.83046 14.4812C6.67468 14.5327 6.70244 14.7398 6.62851 14.8579C6.26509 15.5202 6.59544 16.0034 7.05827 16.4673C6.65203 16.4912 6.21178 16.5326 6.07137 16.0952C5.89594 15.5857 5.7372 15.0718 5.47707 14.5955C5.38971 14.4356 5.44594 14.2497 5.44368 14.0762C5.38028 13.3665 4.65548 12.8352 4.79163 12.0789C4.8444 11.7002 4.30415 12.2411 3.74478 11.5517C3.55834 11.3306 3.12451 10.796 3.19944 10.519C3.35257 10.1373 3.36871 9.6768 3.72224 9.41187C3.87283 9.2948 3.88654 8.92976 3.60567 9.00055C2.8842 9.12125 3.03836 8.57912 2.6158 8.68206C2.32967 8.71251 2.12313 8.61872 1.90076 8.41854C1.23362 7.80495 1.04237 8.25958 0.660124 7.80467C0.916646 5.99772 1.75406 4.32328 3.04595 3.03414Z"
                                  fill="#A1A3AB"
                                />
                              </svg>
                              Worldwide
                            </div>
                            <img
                              width="25"
                              height="25"
                              src="https://img.icons8.com/color/25/rank.png"
                              alt="rank"
                            />
                          </div>
                        ),
                      },
                      {
                        value: "forex",
                        label: (

                          <div className="display-5">
                            <div className="display-1">
                              <img
                                width="20"
                                height="20"
                                src="https://img.icons8.com/color/20/malaysia-circular.png"
                                alt="malaysia-circular"
                              />
                              In Your Country
                            </div>

                            <img
                              width="25"
                              height="25"
                              src="https://img.icons8.com/color/25/rank.png"
                              alt="rank"
                            />
                          </div>
                        ),
                      },
                    ]}
                  />
                </motion.div>
              </div>
            </motion.div>
            <motion.div variants={child}>
              <div className="p-10">
                <Select
                  defaultValue={"AllPositions"}
                  style={{ width: "100%" }}
                  // onChange={handleChange}
                  suffixIcon={
                    <svg
                      width="14"
                      height="10"
                      viewBox="0 0 14 10"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M6.66667 10L0 0H14L6.66667 10Z"
                        fill="var(--fnt)"
                      />
                    </svg>
                  }
                  className="history-select"
                  options={[
                    {
                      value: "AllPositions",
                      label: (
                        <div className="display-5">
                          <div className="display-1">
                            <MenuUnfoldOutlined />
                            All Instruments
                          </div>
                          <img
                            width="25"
                            height="25"
                            src="https://img.icons8.com/color/25/rank.png"
                            alt="rank"
                          />
                        </div>
                      ),
                    },

                    {
                      value: "forex",
                      label: (
                        <div className="display-5">
                          <div className="display-1">
                            <img
                              width="25"
                              height="25"
                              src="https://img.icons8.com/color/25/us-dollar-circled--v1.png"
                              alt="us-dollar-circled--v1"
                            />
                            Forex
                          </div>

                          <img
                            width="25"
                            height="25"
                            src="https://img.icons8.com/color/25/rank.png"
                            alt="rank"
                          />
                        </div>
                      ),
                    },
                    {
                      value: "options",
                      label: (
                        <div className="display-5">
                          <div className="display-1">
                            <svg
                              width="22"
                              height="22"
                              viewBox="0 0 22 22"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <rect
                                x="0.333008"
                                y="0.333374"
                                width="21.3333"
                                height="21.3333"
                                rx="10.6667"
                                fill="#A1A3AB"
                              />
                              <path
                                d="M9.09637 18.962C9.30802 19.0525 9.55412 18.977 9.67774 18.7817L15.3027 9.84418C15.3938 9.69953 15.3993 9.51687 15.3169 9.36765C15.2345 9.21796 15.0771 9.12503 14.9063 9.12503H11.1522L12.5484 3.58412C12.6047 3.36027 12.4907 3.12909 12.2787 3.03799C12.0682 2.94737 11.8205 3.02334 11.6974 3.21834L6.07237 12.1558C5.98127 12.3005 5.97577 12.4832 6.05818 12.6324C6.14058 12.7821 6.29805 12.875 6.4688 12.875H10.2229L8.82674 18.4159C8.77043 18.6398 8.8844 18.8709 9.09637 18.962Z"
                                fill="black"
                              />
                            </svg>
                            Options
                          </div>

                          <img
                            width="25"
                            height="25"
                            src="https://img.icons8.com/color/25/rank.png"
                            alt="rank"
                          />
                        </div>
                      ),
                    },
                    {
                      value: "crypto",
                      label: (
                        <div className="display-5">
                          <div className="display-1">
                            <img
                              width="25"
                              height="25"
                              src="https://img.icons8.com/color/25/bitcoin--v1.png"
                              alt="bitcoin--v1"
                            />
                            Crypto
                          </div>

                          <img
                            width="25"
                            height="25"
                            src="https://img.icons8.com/color/25/rank.png"
                            alt="rank"
                          />
                        </div>
                      ),
                    },
                  ]}
                />
              </div>
            </motion.div>
            <motion.div variants={child}>
              <div className=" leader-rank">
                <div className="display-1">
                  <img src={leader} alt="leader" />
                  <div className="leader-name">
                    Adrian P.
                    <div className="price-amt">$1,743</div>
                  </div>
                </div>
                <div className="mt-20 leader-desc">
                  You are the best trader worldwide this week
                </div>
              </div>
            </motion.div>
            <div style={{ display: "flex", flexDirection: "column" }}>
              {/* ...your header and filters above... */}
              <div style={{ flex: 1, overflowY: "auto" }}>
                <List
                  itemLayout="horizontal"
                  dataSource={data}
                  renderItem={(item, index) => (
                    <motion.div variants={child} key={item.id || index}>
                      <List.Item
                        style={{
                          background: "var(--bg-mn)",
                          // borderRadius: 8,
                          marginBottom: 6,
                          padding: "5px 12px",
                          borderBottom: "2px solid #f7a60047",
                          display: "flex",
                        }}
                      >
                        <Row style={{ width: "100%" }} align="middle">
                          {/* Left - Time and Date */}
                          <Col span={4} className="display-1">
                            {/* <img src={l1} alt='l1' /> */}

                            {index === 0 ? (
                              <img src={l1} width={28} />
                            ) : index === 1 ? (
                              <img src={l2} width={28} />
                            ) : index === 2 ? (
                              <img src={l3} width={28} />
                            ) : (
                              <div class="quiz-medal">
                                <div class="quiz-medal__circle quiz-medal__circle--gold">
                                  <span>{index + 1}</span>
                                </div>
                                <div class="quiz-medal__ribbon quiz-medal__ribbon--left"></div>
                                <div class="quiz-medal__ribbon quiz-medal__ribbon--right"></div>
                              </div>
                            )}
                          </Col>

                          {/* Middle - Icon + Pair + Type */}
                          <Col
                            span={15}
                            style={{
                              display: "flex",
                              alignItems: "flex-start",
                              justifyContent: "flex-start",
                              paddingLeft: "12px",
                            }}
                          >
                            <div>
                              <img
                                src={item.icon}
                                alt={item.pair}
                                style={{
                                  width: 28,
                                  height: "auto",
                                  marginRight: 8,
                                }}
                              />
                            </div>

                            <div>
                              <Text
                                style={{ color: "#E96D00" }}
                                className="pair-h"
                              >
                                {item.pair}
                              </Text>
                            </div>
                          </Col>

                          {/* Right - Profit/Loss + Investment */}
                          <Col span={5} style={{ textAlign: "right" }}>
                            <Text
                              style={{
                                color: item.result >= 0 ? "#1BA136" : "#D74C39",
                                // fontWeight: 600,
                              }}
                              className="result-h v2"
                            >
                              {item.result >= 0
                                ? `+$${item.result}`
                                : `-$${Math.abs(item.result)}`}
                            </Text>
                          </Col>
                        </Row>
                      </List.Item>
                    </motion.div>
                  )}
                />
              </div>
            </div>
          </motion.div>
        </>
      )}
    </>
  );
};

export default LeaderBoard;
